import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Intro = styled.div`
	margin-bottom: 3rem;
`;

export const USAMessage = styled.div`
	margin-bottom: 3rem;
`;

export const Header = styled.h2`
	font-size: 3.4rem;
	margin-bottom: 0.5rem;
	color: ${({ theme }) => theme.colors.black};
	font-family: ${({ theme }) => theme.fonts.SharpSlab};
	font-weight: 700;
	letter-spacing: -1.2px;
`;
